import React from "react"

import RejectedScreen from "../../components/rejected"
import { StepProps } from "../step-registry"

const RejectedStep: React.FC<StepProps> = () => {
  return <RejectedScreen />
}

export default RejectedStep
